import { $authHost, $host } from ".";

export const fetchApplications = async () => {
    const {data} = await $authHost.get('/application')
    return data
}
export const addApplication = async (email,phone_number,name,text) => {
    const {data} = await $host.post('/application/add', {email,phone_number,name,text})
    return data
}
export const deleteApplication = async (id) => {
    const {data} = await $authHost.delete(`/application/${id}`)
    return data
}
